import type { TOffer, TSummaryType } from 'shared/types/TRankingService';

export const getSummaryTypesOrderByProductType = (offer: TOffer): TSummaryType[] => {
  if (offer?.additionalInfo?.isPreapproving) {
    return ['Loading', 'Loading'];
  }

  switch (offer.category) {
    case 'Credit':
      return ['LoanAmount', 'LoanPerMonth'];
    case 'CreditCard':
      return ['LoanLimit', 'LoanGracePeriod'];
    case 'MicroCredit':
      return ['LoanAmount', 'LoanTerm'];
    default:
      return ['LoanAmount', 'LoanPerMonth'];
  }
};
